import { useEffect, ReactNode } from 'react';

type Direction = 'ltr' | 'rtl';

interface DirectionProps {
  children: ReactNode;
  direction: Direction;
}

const DirectionComponent = (props: DirectionProps) => {
  const { children, direction } = props;

  useEffect(() => {
    document.dir = direction;
  }, [direction]);

  return <>{children}</>;
};

export default DirectionComponent;
